import { render } from "./HeroiconsSolidAtSymbol.vue?vue&type=template&id=7096bd58"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidAtSymbol.vue"]])

export default __exports__